import z from "zod";

import { createComponentSchemas } from "@shared/content-types/utils";
import { BackgroundMediaSchema } from "@shared/ui/background-media/model";

const UniversalGalleryItemBaseSchema = z.object({
  backgroundMedia: BackgroundMediaSchema.base,
  title: z.string().min(1),
  variant: z
    .enum(["trails", "default"])
    .default("default")
    .optional()
    .nullable(),
  difficulty: z
    .enum(["very hard", "hard", "medium", "easy"])
    .optional()
    .nullable(),
  trailNumber: z.string().optional().nullable(),
});

export const UniversalGalleryItemSchema = createComponentSchemas(
  "ui.universal-gallery-item",
  UniversalGalleryItemBaseSchema,
);

const UniversalGallerySectionBaseSchema = z.object({
  subtitle: z.string().optional().nullable(),
  title: z.string().min(1),
  gallery: z
    .array(UniversalGalleryItemSchema.base)
    .min(0)
    .optional()
    .nullable(),
});

export const UniversalGallerySectionSchema = createComponentSchemas(
  "ui.universal-gallery-section",
  UniversalGallerySectionBaseSchema,
);
